import { PaymentInstrumentsApiBase } from './paymentApi';

class PaymentInstrumentsApi extends PaymentInstrumentsApiBase {

}

export default new PaymentInstrumentsApi();
